<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <left-panel activeTab="10" *ngIf="this.auth?.detailuser && this.SkipQue != 'Skipque'"></left-panel>
        <left-panel activeTab="11" *ngIf="this.auth?.detailuser &&  this.SkipQue == 'Skipque'"></left-panel>

        <app-left-panel-prelogin activeTab="3" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin>

    </div>
    <div class="post-login-1-col-2" >
        <div class="full" id="map">
        </div>
    </div>
    <div class="post-login-1-col-3" *ngIf = "this.SkipQue != 'Skipque'">
        <div class="p-25" *ngFor="let item of this.BranchLocationList">
            <div class="border-bottom pt-15 pb-15">
                <grid-row class="justify-content-between mt-10">
                    <grid-col col="auto">
                        <div class="font-500 font-size-14px line-h-20 color-base-1300">
                            <span class="circle-tag active"></span> 
                            <span>{{item?.nameEn}}</span>
                        </div>
                        <div class="font-400 font-size-14px line-h-20 color-base-500 mt-10">
                            <span>{{item?.fromDay}}</span> {{"to" | translate}} <span>{{item?.endDay}}</span>
                        </div>
                        <div class="font-400 font-size-14px line-h-20 color-base-500">
                            <span>{{item?.startTime}}</span> {{"to" | translate}} <span>{{item?.endTime}}</span>
                        </div>
                        <div class="font-500 font-size-14px line-h-20 color-primary link"
                            (click)="Direction(item?.latitude,item?.longitude)">
                            {{"Directions" | translate}}
                        </div>
                    </grid-col>
                    <!-- <grid-col col="auto">
                        <ng-icon iconClass="icon-arrow-right"  width="24" height="24"></ng-icon>
                    </grid-col> -->
                </grid-row>
            </div>
        </div>
    </div>
    <div class="post-login-1-col-3" *ngIf = "this.SkipQue == 'Skipque'">
        <div class="p-25" *ngFor="let item of this.SkikQList">
            <div class="border-bottom pt-15 pb-15" (click)="showModal(1,item)">
                <grid-row class="justify-content-between mt-10">
                    <grid-col col="auto">
                        <div class="font-500 font-size-14px line-h-20 color-base-1300">
                            <span class="circle-tag active"></span> 
                            <span>{{item?.name}}</span>
                        </div>
                        <div class="font-400 font-size-14px line-h-20 color-base-500 mt-10">
                             {{"Theestimatedwaiting" | translate}} <span>{{item?.estimatedWaitTime}}</span>
                        </div>
                        <div class="font-400 font-size-14px line-h-20 color-base-500">
                              <span>{{item?.customersWaiting}}</span> {{"CustInQue" | translate}}
                        </div>
                        <!-- <div class="font-500 font-size-14px line-h-20 color-primary link"
                            (click)="Direction(item?.latitude,item?.longitude)">
                            {{"Directions" | translate}}
                        </div> -->
                    </grid-col>
                    <grid-col col="auto" >
                        <ng-icon iconClass="icon-arrow-right"  width="24" height="24"></ng-icon>
                        <!-- (click)="showModal(1,item)" -->
                    </grid-col>
                </grid-row>
            </div>
        </div>
    </div>
</div>

<modal modalID="1" modalClass="height-auto-flex" [events]="modalObservable.asObservable()" [backdropDismiss]="false"
    [whiteButtonStatus]="true" whiteButtonText="cancel" [modalDoneButtonDisabled]="this.selectedServices != ''? false : true" modalDoneButtonText="GetaVirtualTicket"
    (doneButton)="next()">
    <div class="font-size-22px color-base-700 font-400 line-h-25  letter-spacing-03">
        {{"Pleasecheckthedetails" | translate}}
    </div>
    <grid-row class="mt-30">
        <grid-col col="12">
            <div class="font-500 font-size-13px color-base-500">
                {{ "typeofservices" | translate }}
            </div>
        </grid-col>
        <grid-col col="12">
            <div class="form-group">
                <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedServices"
                    [dropDownData]="this.brnchServices" (itemselected)="onServicesChange($event)">
                    {{this.selectedServices}}
                </drop-down-list>
            </div>
        </grid-col>
    </grid-row>
   
    <div class="border border-color-900 p-16 br-12 box-shadow mt-20" *ngIf="this.SelectedMarker != undefined && this.SelectedMarker != null">
        <grid-row class="justify-content-between align-item-center border-bottom border-color-2100 pb-15">
            <grid-col col="auto">
                <div class="color-base-1300 font-size-14px font-500">
                    {{this.SelectedMarker.name}}
                </div>
            </grid-col>
            <grid-col col="auto">
                <button class="btn-dft green" *ngIf="this.SelectedMarker.branchOpen == true" >
                    {{"open" | translate}} 
                </button>
                <button class="btn-dft green" *ngIf="this.SelectedMarker.branchOpen == false" >
                    {{"close" | translate}}
                </button>
            </grid-col>
        </grid-row>
        <div class="border-bottom border-color-2100 pb-15">
            <div class="color-base-1300 font-size-14px font-500 mt-15">
                {{"BusinessHours" | translate}}
            </div>
            <div class="color-base-500 font-size-14px font-400 mt-15" *ngIf="this.SelectedMarker.startDay != '' && this.SelectedMarker.endDay != ''">
                <!-- Sunday to Thursday -->
                 {{this.SelectedMarker.startDay}} {{"to" | translate}} {{this.SelectedMarker.endDay}}
            </div>
            <div class="color-base-500 font-size-14px font-400 mt-5">
              {{this.SelectedMarker.openTime}} am {{"to" | translate}} {{this.SelectedMarker.closeTime}} pm
            </div>
            <grid-row class="justify-content-between align-item-center mt-15">
                <grid-col col="auto">
                    <div class="color-base-1300 font-size-14px font-500 link-u">
                        {{this.SelectedMarker.contactNumber}}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="color-base-1300 font-size-14px font-500 link-u">
                     {{"Getthere" | translate}}
                    </div>
                </grid-col>
            </grid-row>
        </div>
        <div class="color-primary font-size-14px font-500 mt-15">
            <!-- 3 customers in queue -->
          <span>{{this.SelectedMarker.customersWaiting}}</span>    {{"CustInQue" | translate}}
        </div>
        <div class="color-base-500 font-size-12px font-400 mt-10">
            {{"Theestimatedwaiting" | translate}} <span>{{this.SelectedMarker.estimatedWaitTime}}</span>
        </div>
    </div>

</modal>